import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvailabilityIconComponent } from './availability-icon.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [AvailabilityIconComponent],
  exports: [AvailabilityIconComponent],
  imports: [CommonModule, MatTooltipModule, MatIconModule],
})
export class AvailabilityIconModule {}
